export const COLORS = {
  completed: "green",
  accomplished: "green",
  not_accomplished: "red",
  on_track: "green",
  caution: "yellow",
  issue: "red",
  paused: "gray",
  outdated: "gray",
  pending: "gray",
};

export const TITLES = {
  completed: "Completed",
  accomplished: "Accomplished",
  not_accomplished: "Not Accomplished",
  on_track: "On Track",
  caution: "Caution",
  issue: "Issue",
  paused: "Paused",
  outdated: "Outdated",
  pending: "Pending",
};

export const CIRCLE_BORDER_COLORS = {
  green: "border-green-600",
  yellow: "border-yellow-400",
  red: "border-red-500",
  gray: "border-gray-500",
};

export const CIRCLE_BACKGROUND_COLORS = {
  green: "bg-green-600",
  yellow: "bg-yellow-400",
  red: "bg-red-500",
  gray: "bg-gray-500",
};
